import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { User, Menu, X } from 'lucide-react';

const Navbar = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            setIsOpen(false);
            navigate('/');
        } catch (error) {
            console.error('Eroare la logout:', error);
        }
    };

    const closeMenu = () => setIsOpen(false);

    return (
        <nav className="bg-white shadow-md sticky top-0 z-50">
            <div className="max-w-6xl mx-auto px-4">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-2" onClick={closeMenu}>
                        
                        <span className="text-xl font-bold text-gray-900">Affinity Club</span>
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden lg:flex items-center space-x-6">
                        <Link to="/" className="text-gray-800 hover:text-purple-600 font-medium transition">
                            Acasă
                        </Link>
                        <Link to="/despre" className="text-gray-800 hover:text-purple-600 font-medium transition">
                            Despre noi
                        </Link>
                        <Link to="/pricing" className="text-gray-800 hover:text-purple-600 font-medium transition">
                            Membership
                        </Link>
                        <Link to="/coaching" className="text-gray-800 hover:text-purple-600 font-medium transition">
                            Coaching
                        </Link>
                        <Link to="/evenimente" className="text-gray-800 hover:text-purple-600 font-medium transition">
                            Evenimente
                        </Link>
                        {currentUser && (
                            <Link to="/teste" className="text-gray-800 hover:text-purple-600 font-medium transition">
                                Teste
                            </Link>
                        )}
                        {currentUser && (
                            <Link to="/profile" className="flex items-center gap-1 text-gray-800 hover:text-purple-600 font-medium transition">
                                <User size={18} />
                                Profil
                            </Link>
                        )}
                    </div>

                    {/* Desktop Auth Button */}
                    <div className="hidden lg:block">
                        {currentUser ? (
                            <button
                                onClick={handleLogout}
                                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition text-sm"
                            >
                                Logout
                            </button>
                        ) : (
                            <Link
                                to="/login"
                                className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition text-sm"
                            >
                                Login
                            </Link>
                        )}
                    </div>

                    {/* Mobile Hamburger Button */}
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition"
                    >
                        {isOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="lg:hidden border-t border-gray-200 bg-white">
                    <div className="px-4 py-3 space-y-1">
                        <Link to="/" onClick={closeMenu} className="block px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                            Acasă
                        </Link>
                        <Link to="/despre" onClick={closeMenu} className="block px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                            Despre noi
                        </Link>
                        <Link to="/pricing" onClick={closeMenu} className="block px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                            Membership
                        </Link>
                        <Link to="/coaching" onClick={closeMenu} className="block px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                            Relationship Coaching
                        </Link>
                        <Link to="/evenimente" onClick={closeMenu} className="block px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                            Evenimente
                        </Link>
                        {currentUser && (
                            <Link to="/teste" onClick={closeMenu} className="block px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                                Teste
                            </Link>
                        )}
                        {currentUser && (
                            <Link to="/profile" onClick={closeMenu} className="flex items-center gap-2 px-3 py-3 rounded-lg text-gray-800 hover:bg-purple-50 hover:text-purple-600 font-medium transition">
                                <User size={18} />
                                Profil
                            </Link>
                        )}

                        <div className="pt-2 border-t border-gray-200 mt-2">
                            {currentUser ? (
                                <button
                                    onClick={handleLogout}
                                    className="w-full bg-red-500 text-white px-4 py-3 rounded-lg hover:bg-red-600 transition font-medium"
                                >
                                    Logout
                                </button>
                            ) : (
                                <Link
                                    to="/login"
                                    onClick={closeMenu}
                                    className="block text-center bg-purple-600 text-white px-4 py-3 rounded-lg hover:bg-purple-700 transition font-medium"
                                >
                                    Login
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;